import { IconButton } from "@mui/material";
import { expenseJobOrderColNm } from "constants/expenseJobOrderConstant";
import { jobOrderColNm } from "constants/jobOrderConstant";
import dayjs from "dayjs";
import { pettyCashColNm } from "pages/Menu1/PettyCash/constant";
import { ArticleRounded, ChevronRightRounded } from "resource/muiImport";
import { numberFormat } from "utils";

export const jobOrderColumns = [
  // {
  //   field: 'ShowDetail',
  //   headerName: '',
  //   width: 40,
  //   align: 'center',
  //   renderCell: (params) => {
  //   return (
  //     <IconButton size="small" >
  //     <ArticleRounded color="primary"/>
  //     </IconButton>
  //   )}
  // },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 100,
  },
  {
    field: "AptTm",
    headerName: jobOrderColNm.AptTm,
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 100,
  },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 100,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    width: 170,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 100,
  },
  {
    field: "Rmk",
    headerName: jobOrderColNm.Rmk,
    flex: 1,
    minWidth: 120,
  },
]

export const pcItemColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => id ? (
      <IconButton size="small" >
        <ArticleRounded color="primary" />
      </IconButton>
    ) : null
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "IsCost",
    headerName: pettyCashColNm.IsCost,
    width: 70,
    valueFormatter: ({ id, value }) => id === 0 ? "" : value == null ? "" : value ? "ต้นทุน" : "รายได้",
    cellClassName: ({ id, value }) => id === 0 ? "" : value === 0 ? 'income' : 'cost',
  },
  {
    field: "JobOrdId",
    headerName: pettyCashColNm.JobOrdId,
    width: 70,
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },
  {
    field: "PayAmnt",
    headerName: pettyCashColNm.PayAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row, value}) => row.InOutTyp === "I" || row.InOutTypItm === "I" ? value * -1 : value,
    valueFormatter: ({ value }) => numberFormat(value)
  },
  {
    field: 'AddExpense',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id, row }) => id && row.PCItmId ? (
      <IconButton size="small" >
        <ChevronRightRounded color="primary" />
      </IconButton>
    ) : null
  },
]


export const subcontractColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => id ? (
      <IconButton size="small" >
        <ArticleRounded color="primary" />
      </IconButton>
    ) : null
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "JobOrdId",
    headerName: expenseJobOrderColNm.JobOrdId,
    width: 70,
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },
  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => numberFormat(value)
  },
  {
    field: 'AddExpense',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id, row }) => id ? (
      <IconButton size="small" >
        <ChevronRightRounded color="primary" />
      </IconButton>
    ) : null
  },
]
export const expenseColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => id ? (
      <IconButton size="small" >
        <ArticleRounded color="primary" />
      </IconButton>
    ) : null
  },
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "IsOwnRcpt",
    headerName: expenseJobOrderColNm.IsOwnRcpt,
    width: 60,
    valueFormatter: ({ id, value }) => id === 0 ? "" : value == null ? "" : value ? "บริษัท" : "ลูกค้า",
  },
  {
    field: "JobOrdId",
    headerName: expenseJobOrderColNm.JobOrdId,
    width: 70,
  },
  {
    field: "ExpNm",
    headerName: expenseJobOrderColNm.ExpNm,
    flex: 1,
    minWidth: 120,
  },
  {
    field: "Total",
    headerName: expenseJobOrderColNm.Total,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => numberFormat(value)
  },
  // {
  //   field: 'AddExpense',
  //   headerName: '',
  //   width: 40,
  //   align: 'center',
  //   renderCell: ({id}) => id? (
  //       <IconButton size="small" >
  //         <ChevronRightRounded color="primary" />
  //       </IconButton>
  //     ): null
  // },
]